export default __webpack_public_path__ + "static/rovo-dialect-diagram-light-7a5ff108751deeda995731d471c71487aa4062009ebcecac5d42fe799653ee8f.png";